import * as THREE from 'three';

// const TWEEN = require('@tweenjs/tween.js');
import * as TWEEN from '@tweenjs/tween.js';
import {
    cameraLoadingPosition,
    cameraTransitionSpeed,
    initialOrbitControlsSettings
} from '../settings';

//Scene subjects
import addLights from './scene-subjects/addLights';
import addShadowPlane from './scene-subjects/addShadowPlane';
import addShipModel from './scene-subjects/addShipModel';


export default class SceneManager {
    constructor(container, shipModelUrl, callbackOnLoad) {

        this.OrbitControls = require('three-orbit-controls')(THREE);
        this.container = container;
        this.containerDimensions = {
            width: this.container.offsetWidth,
            height: this.container.offsetHeight
        };
        this.scene = new THREE.Scene();
        this.renderer = this.buildRenderer(this.containerDimensions);
        this.camera = this.buildCamera(this.containerDimensions);
        this.controls = this.buildOrbitControls(this.camera, this.renderer);
        this.loadingManager = this.buildLoadingManager(callbackOnLoad, this.changeCameraPosition);

        this.initSceneSubjects(this.scene, shipModelUrl, this.loadingManager);
    }

    initSceneSubjects(scene, shipModelUrl, loadingManager) {
        addLights(scene);
        addShadowPlane(scene);
        addShipModel(scene, shipModelUrl, loadingManager);
    }

    buildLoadingManager(callback) {
        const loadingManager = new THREE.LoadingManager();
        loadingManager.onLoad = function () {
            callback();
            console.log('Loading complete!');
        };

        return loadingManager;
    }

    buildRenderer({width, height}) {
        const renderer = new THREE.WebGLRenderer({antialias: true, alpha: true});
        renderer.shadowMap.enabled = true;
        renderer.shadowMap.type = THREE.PCFSoftShadowMap;
        renderer.setSize(width, height);
        renderer.autoClear = false;
        renderer.setClearColor(0x000000, 0);

        this.container.appendChild(renderer.domElement);

        return renderer;
    }

    buildCamera({width, height}) {
        const fieldOfView = 35;
        const aspectRatio = width / height;
        const nearPlane = 1;
        const farPlane = 1000;
        const camera = new THREE.PerspectiveCamera(
            fieldOfView,
            aspectRatio,
            nearPlane,
            farPlane
        );

        camera.position.set(
            cameraLoadingPosition.x,
            cameraLoadingPosition.y,
            cameraLoadingPosition.z
        );
        camera.lookAt(new THREE.Vector3(0, 0, 0));

        return camera;
    }

    buildOrbitControls(camera, renderer) {
        const controls = new this.OrbitControls(camera, renderer.domElement);
        this.setOrbitControlSettings(controls, initialOrbitControlsSettings);

        return controls;
    }

    setOrbitControlSettings(controls, settings) {
        const {
            minDistance,
            maxDistance,
            enableDamping,
            enableKeys,
            enablePan,
            dampingFactor,
            minAzimuthAngle,
            maxAzimuthAngle,
            minPolarAngle,
            maxPolarAngle,
            rotateSpeed
        } = settings;

        controls.minDistance = minDistance;
        controls.maxDistance = maxDistance;
        controls.enableDamping = enableDamping;
        controls.dampingFactor = dampingFactor;
        controls.enableKeys = enableKeys;
        controls.enablePan = enablePan;
        controls.minAzimuthAngle = minAzimuthAngle;
        controls.maxAzimuthAngle = maxAzimuthAngle;
        controls.minPolarAngle = minPolarAngle;
        controls.maxPolarAngle = maxPolarAngle;
        controls.rotateSpeed = rotateSpeed;

    }

    onWindowResize() {
        const width = this.container.offsetWidth;
        const height = this.container.offsetHeight;

        this.containerDimensions.width = width;
        this.containerDimensions.height = height;

        this.camera.aspect = width / height;
        this.camera.updateProjectionMatrix();

        this.renderer.setSize(width, height);
    };

    getTwoDCoordinatesFromThreeD(threeDCoordinates) {
        const canvas = this.renderer.domElement;
        const vector = new THREE.Vector3(
            threeDCoordinates.x,
            threeDCoordinates.y,
            threeDCoordinates.z
        );

        vector.project(this.camera);
        vector.x = Math.round((vector.x + 1) * canvas.width / 2);
        vector.y = Math.round((-vector.y + 1) * canvas.height / 2);

        return {
            x: vector.x,
            y: vector.y
        }
    }

    changeCameraPosition(coordinates) {

        this.setOrbitControlSettings(this.controls, initialOrbitControlsSettings);

        const camera = this.camera;
        const from = {
            x: camera.position.x,
            y: camera.position.y,
            z: camera.position.z,
        };
        const to = {
            x: coordinates.x,
            y: coordinates.y,
            z: coordinates.z,
        };

        new TWEEN.Tween(from)
            .to(to, cameraTransitionSpeed)
            .easing(TWEEN.Easing.Quadratic.Out)
            .onUpdate(function () {
                camera.position.set(from.x, from.y, from.z);
                camera.lookAt(new THREE.Vector3(0, 0, 0));
            })
            .onComplete(function () {
                camera.lookAt(new THREE.Vector3(0, 0, 0));
            })
            .start()
        ;
    }

    update() {
        this.renderer.render(
            this.scene,
            this.camera
        );
        this.controls.update();
        TWEEN.update();
    };
}